require('./index.css');

import React from 'react'
import Helmet from 'react-helmet';
import Link from 'gatsby-link'
import { Scene } from '../scene/scene';
import { Title } from '../components/title';
import { Intro } from '../components/intro';
import { PortfolioWrapper } from '../components/portfolio-wrapper';
import { PortfolioItem } from '../components/portfolio-item';

const IndexPage = () => (
  <div>
    <Helmet>
      <title>Idle Hands</title>
      <script src="https://cdnjs.cloudflare.com/ajax/libs/three.js/93/three.min.js" />
      <link href="https://fonts.googleapis.com/css?family=Space+Mono" rel="stylesheet" />
    </Helmet>
    <div className="first">
      <Scene />
      <Title />
      <Intro />
    </div>
    <PortfolioWrapper>
      <PortfolioItem video="/video/paul-tucker.mp4">
        <h2>Paul Tucker</h2>
        <a target="_blank" href="https://paul-tucker.com">visit the website</a>
        <p>Motion oriented website for a premium personal trainer.</p>
        <p>Collaboration with LOBSTER and SALT</p>
      </PortfolioItem>

      <PortfolioItem video="/video/listenfestival.mp4">
        <h2>Listen Festival</h2>
        <a target="_blank" href="https://listenfestival.be">visit the archived 2018 version</a>
        <p>Festival website where the intro graphic is a functioning music toybox. Arrange your own track.</p>
        <p>Collaboration with LOBSTER and Alexander Choeb</p>
      </PortfolioItem>

      <PortfolioItem image="/nike.jpg">
        <h2>NikeLab at VOO Store Berlin</h2>
        <p>In-store installation for Ricardo Tisci's capsule collection for NikeLab</p>
        <p>Collaboration with Set-Office Architects & Michiel De Vreede</p>
      </PortfolioItem>

      <PortfolioItem video="/video/classicclubbing.mp4">
        <h2>Classic Clubbing</h2>
        <a target="_blank" href="http://classicclubbing.be">visit the archived 2018 version</a>
        <p>National Orchestra of Belgium concert series in nightclubs.</p>
        <p>Combining nightlife visuals with classical music, the 3D sphere is real-time generated to a classic score.</p>
        <p>Collaboration with LOBSTER</p>
      </PortfolioItem>

      <PortfolioItem video="/video/genworth.mp4">
        <h2>Genworth.com</h2>
        <a target="_blank" href="https://genworth.com">visit the website</a>
        <p>Large scale corporate insurance site.</p>
        <p>Development for Edenspiekermann Los Angeles</p>
      </PortfolioItem>

      <PortfolioItem video="/video/kriket.mp4">
        <h2>KRIKET</h2>
        <a target="_blank" href="https://kriket.be">visit the website</a>
        <p>Delicious looking Shopify wrapper for Belgium's first snack containing real crickets.</p>
        <p>Design by Studio Gloria</p>
      </PortfolioItem>

      <PortfolioItem video="/video/devon.mp4">
        <h2>New&nbsp;York&nbsp;Fashion&nbsp;Week: Devon&nbsp;Halfnight&nbsp;Leflufy</h2>
        <p>Imposition of a VR showroom onto a real life showroom. All models scanned in 3D, represented in a VR environment inspired by the designer's collection</p>
        <p>Collaboration with Tom Galle, Moises Sanabria and Alissa Davis</p>
      </PortfolioItem>
    </PortfolioWrapper>
  </div>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js